export default function (url: string): string {
  try {
    return decodeURI(url)
  } catch (error) {
    console.error(`Error decoding ${url} - ${error}`)
    return url
  }
}
